/* eslint-disable */
import Vue from 'vue'
import msgboxVue from './index.vue'

const defaults = {
  redbagImg: '',
  onRedbagClick: null,
}

function merge(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    const source = arguments[i] || {}
    for (const prop in source) {
      if (Object.prototype.hasOwnProperty.call(source, prop)) {
        const value = source[prop]
        if (value !== undefined) {
          target[prop] = value
        }
      }
    }
  }
  return target
}

const MessageBoxConstructor = Vue.extend(msgboxVue)
let instance

function initInstance(options) {
  instance = new MessageBoxConstructor({
    el: document.createElement('div'),
  })
  merge(instance, options)
}

function ensureInstance(options) {
  if (!instance) {
    initInstance(options)
    document.body.appendChild(instance.$el)
  }
}

const MessageBox = {
  show(options = {}) {
    ensureInstance(options)
    const opts = merge({}, defaults, options)
    Vue.nextTick(() => {
      instance.show(opts)
    })
    return instance
  },

  showGuide(options = {}) {
    ensureInstance(options)
    Vue.nextTick(() => {
      instance.showGuide(options)
    })
    return instance
  },

  close() {
    if (instance) {
      instance.doClose()
    }
  },
}

MessageBox.install = function install(Vue) {
  Vue.prototype.$RaiseBoxMineRedbag = MessageBox
  return MessageBox
}

export default MessageBox
